import { Badge, Card, CardBody } from "@odingard/design-system";
import { EmptyState } from "@odingard/design-system";
import { useAsync } from "../../lib/useAsync";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";

export function Notifications() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(
    async () => {
      const [dash, review] = await Promise.all([api.dashboard(orgId), api.reviewQueue(orgId)]);
      return { metrics: dash.metrics, reviewCount: review.items.length };
    },
    [orgId],
  );

  const items = state.data
    ? [
        state.data.metrics.overdueObligations > 0 && {
          tone: "danger" as const,
          title: `${state.data.metrics.overdueObligations} overdue obligation(s)`,
          body: "Review obligations that have passed their due date.",
        },
        state.data.reviewCount > 0 && {
          tone: "warning" as const,
          title: `${state.data.reviewCount} extraction(s) awaiting review`,
          body: "Fields with low confidence need human verification.",
        },
        state.data.metrics.upcomingRenewals > 0 && {
          tone: "info" as const,
          title: `${state.data.metrics.upcomingRenewals} upcoming renewal(s)`,
          body: "Contracts approaching their renewal window.",
        },
      ].filter(Boolean)
    : [];

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Notifications</h1>
          <p>Alerts across your Contract AI workspace.</p>
        </div>
      </div>
      {state.data && items.length === 0 ? (
        <EmptyState icon="🔔" title="All caught up" description="No alerts right now." />
      ) : (
        <div className="ods-stack">
          {items.map((n, i) =>
            n ? (
              <Card key={i}>
                <CardBody>
                  <div className="ods-row" style={{ justifyContent: "space-between" }}>
                    <div>
                      <strong>{n.title}</strong>
                      <p style={{ margin: "4px 0 0", color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>{n.body}</p>
                    </div>
                    <Badge tone={n.tone}>{n.tone === "danger" ? "Action needed" : n.tone === "warning" ? "Review" : "Info"}</Badge>
                  </div>
                </CardBody>
              </Card>
            ) : null,
          )}
        </div>
      )}
    </>
  );
}
